// src/components/ProductRepostPreview.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductRepostPreview.css';

import placeholderProduct from '../assets/placeholder-product.png';
import blueTickIcon from '../assets/bluetick-icon.png';

function ProductRepostPreview({ productSnapshot }) {
  const navigate = useNavigate();

  if (!productSnapshot) return null;

  const productId = productSnapshot.productId || productSnapshot._id || '';
  const media = Array.isArray(productSnapshot.media) ? productSnapshot.media : [];
  const imageUrl = media[0] || placeholderProduct;

  const productName = productSnapshot.name || 'Product';
  const description = productSnapshot.description || 'View this product on BarterFi.';

  const businessName =
    productSnapshot.businessName ||
    productSnapshot.storeName ||
    productSnapshot.businessUsername ||
    productSnapshot.ownerUsername ||
    'BarterFi Merchant';

  const openProduct = () => {
    if (!productId) return;

    navigate(`/product/${productId}`, {
      state: { from: 'feed' },
    });
  };

  return (
    <div
      className="product-repost-preview"
      onClick={openProduct}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') openProduct();
      }}
    >
      <div className="product-repost-image-wrap">
        <img
          src={imageUrl}
          alt={productName}
          className="product-repost-image"
          onError={(e) => {
            e.currentTarget.src = placeholderProduct;
          }}
        />
      </div>

      <div className="product-repost-info">
        <div className="product-repost-store-row">
          <span className="product-repost-store">
            {businessName}
          </span>

          <img
            src={blueTickIcon}
            alt="Verified merchant"
            className="product-repost-blue-tick"
          />
        </div>

        <h4 className="product-repost-name">
          {productName}
        </h4>

        <p className="product-repost-description">
          {description}
        </p>



      </div>
    </div>
  );
}

export default ProductRepostPreview;
